import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Duurt de bestelling langer/korter?',
  text: {
    [OrderMethod.Pickup]:
      'De klant verwacht de bestelling op te halen op <strong>{{date}}</strong> om <strong>{{time}}</strong><br/> Indien nodig kunt u de tijd hier aanpassen.',
    [OrderMethod.OnSite]:
      'De klant verwacht de bestelling aan <strong>{{table}}</strong><br/><strong>{{date}}</strong> om <strong>{{time}}</strong><br/> Indien nodig kun je de tijd hier wijzigen.',
    // A table order whose table the backend could not name.
    on_site_without_table:
      'De klant verwacht de bestelling aan zijn tafel op <strong>{{date}}</strong> om <strong>{{time}}</strong><br/> Indien nodig kun je de tijd hier wijzigen.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'De klant verwacht de bestelling bezorgd te krijgen op <strong>{{date}}</strong> om <strong>{{time}}</strong><br/> Indien nodig kunt u de tijd hier aanpassen.',
      [DeliveryMode.External]:
        'Chauffeur arriveert om <strong>{{time}}{{confidenceLabel}}</strong> om de bestelling op te halen',
    },
  },
  labels: {
    today: 'Vandaag',
  },
  confidence_labels: {
    estimated: ' (geschat!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Nieuwe afhaaltijd bevestigen',
    confirm_on_site: 'Nieuwe serveertijd bevestigen',
    confirm_delivery: 'Nieuwe bezorgtijd bevestigen',
  },
  confirmation_modal: {
    description: 'Weet u zeker dat u de tijd wilt wijzigen van {{currentPickupTime}} naar {{newPickupTime}}?',
    ok_button_text: 'Nieuwe tijd bevestigen',
    cancel_button_text: 'Nee, originele tijd herstellen',
  },
};
